import { fetcherInternal } from '@/modules/api/fetcher';
import { DEFAULT_SEGMENT, type RiskSegment } from './constants';

export async function resolveRiskSegmentClient(): Promise<RiskSegment> {
  try {
    const { segment } = await fetcherInternal<{ segment: RiskSegment }>(
      '/risk-segment'
    );
    return segment || DEFAULT_SEGMENT;
  } catch {
    return DEFAULT_SEGMENT;
  }
}
